import { FilterQueryParams } from 'src/utils/types';
import request from './utils';
import * as ROUTES from 'src/api/routes';
import { DocumentScanListItemResponse, DocumentScanResponse } from 'common/lib/model/documentScan/DocumentScan';
import { DocumentScanLlmTraceResponse } from 'common/lib/model/documentScan/DocumentScanTrace';
import { PaginatedResult } from 'common/lib/util/pagination';

export async function getDocumentScan(documentScanId: string): Promise<DocumentScanResponse> {
    const result = await request({ ...ROUTES.GET_DOCUMENT_SCAN, pathParams: { documentScanId } });
    return result.data.documentScan;
}

export async function getDocumentScanLlmTrace(documentScanId: string): Promise<DocumentScanLlmTraceResponse> {
    const result = await request({ ...ROUTES.GET_DOCUMENT_SCAN_LLM_TRACE, pathParams: { documentScanId } });
    return result.data;
}

export async function getDocumentScans(
    facilityId: number,
    params: FilterQueryParams & { hasEncounter?: boolean; encounterNumber?: string } = {},
): Promise<PaginatedResult<DocumentScanListItemResponse[]>> {
    const { hasEncounter, encounterNumber, ...restParams } = params;
    const requestParams: any = { facilityId, ...restParams };

    if (hasEncounter !== undefined) {
        requestParams.hasEncounter = hasEncounter.toString();
    }

    if (encounterNumber) {
        requestParams.encounterNumber = encounterNumber;
    }

    if (restParams.pagination) {
        requestParams.pagination = JSON.stringify(restParams.pagination);
    }

    const result = await request({ ...ROUTES.GET_DOCUMENT_SCANS, params: requestParams });

    return { result: result.data.result || [], count: result.data.count || 0 };
}
